import CloseFullscreenRoundedIcon from "@mui/icons-material/CloseFullscreenRounded"
import OpenInFullRoundedIcon from "@mui/icons-material/OpenInFullRounded"
import IconButton from "@mui/material/IconButton"
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux"
import { setObjectsExpandedAsync } from "../../../store/slices/editor.slice"
import ButtonWithTooltip from "../../common/ButtonWithTooltip"

interface Props {
    disabled?: boolean
}

const ObjectsTreeControlExpand = ({ disabled = false }: Props) => {
    const dispatch = useAppDispatch()
    const editor = useAppSelector((state) => state.editor)
    const objectsExpanded: boolean = editor.value.settings.objectsExpanded

    const handleToggleExpanded = () => dispatch(setObjectsExpandedAsync(!objectsExpanded))

    return (
        <ButtonWithTooltip
            tooltipTitle={objectsExpanded ? "collapse all objects" : "expand all objects"}
            buttonComponent={
                <IconButton onClick={handleToggleExpanded} disabled={disabled}>
                    {objectsExpanded && <CloseFullscreenRoundedIcon fontSize="small" />}
                    {!objectsExpanded && <OpenInFullRoundedIcon fontSize="small" />}
                </IconButton>
            }
            disabled={disabled}
        />
    )
}

export default ObjectsTreeControlExpand
